export default __webpack_public_path__ + "static/media/pol.b31e6f52.svg";